export interface CollectorSettings {
  targetOs: string
  outputFormat: string
  encryptionPassword: string
  compressionLevel: number
  cpuLimit: number
  iopsLimit: number
  progressTimeout: number
  timeout: number
}

export const DEFAULT_COLLECTOR_SETTINGS: CollectorSettings = {
  targetOs: 'windows_x86',
  outputFormat: 'zip',
  encryptionPassword: '',
  compressionLevel: 5,
  cpuLimit: 0,
  iopsLimit: 0,
  progressTimeout: 600,
  timeout: 3600,
}
